import { render, staticRenderFns } from "./orderDetailDialog.vue?vue&type=template&id=307de94c&scoped=true"
import script from "./orderDetailDialog.vue?vue&type=script&lang=js"
export * from "./orderDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./orderDetailDialog.vue?vue&type=style&index=0&id=307de94c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307de94c",
  null
  
)

export default component.exports